import { AdContent } from "./ad-content.model";
import { OrderAdDetail } from "./order-ad-detail.model";
import { OrderHeader } from "./order-header.model";
import { OrderService } from "./order-service";

export class Order {
	orderHeader: OrderHeader;
	orderAdDetails: OrderAdDetail[] = [];
	adContents: AdContent[] = [];
	orderServices: OrderService[] = [];
	canModify: boolean = true;
	canCancel: boolean = true;
	modifiedDate?: string;
	subscriberDiscountApplied?: boolean;
	currencyCode?: string; // should be removed and instead use orderHeader. Remains until API is updated to move to orderHeader.
	priceGross?: number;
	discountAmount?: number; // Currently missing from API and being calculated from lines in FE
	priceNetExComm?: number; // Currently missing from API and being calculated from lines in FE //TODO: seems redundant
	//priceCommissionTotal?: number; // Currently missing from API and being calculated from lines in FE //TODO: seems redundant
	taxPercentage?: number; // currently always empty
	//taxAmount?: number; // Currently missing from API - always 0
	materialAgencyName?: string;
	materialContactFirstName?: string;
	materialContactLastName?: string;
	materialContactEmail?: string;
	materialContactPhone?: string;

	constructor() {
		this.orderHeader = new OrderHeader();
	}
}
